import(/* webpackMode: "eager" */ "/home/skillsewa/r/skillsewa.com-trans/node_modules/next/dist/client/app-dir/link.js");
